const care = {
  residentCare: {
    hero: {
      eyebrow: "બીજું ઘર",
      title: "નિવાસી સંભાળ",
      subtitle: "એક પ્રેમાળ ઘર — સંસ્થા નહીં.",
    },
    items: {
      comfortableStay: {
        title: "આરામદાયક રહેઠાણ",
        desc: "સ્વચ્છ, હવાઉજાસવાળા ઓરડા અને દરેક માળે સેવકો.",
      },
      nutritiousMeals: {
        title: "પૌષ્ટિક ભોજન",
        desc: "ત્રણ ટંકનું ભોજન + ચા, વડીલોની આહારની જરૂરિયાત મુજબ તૈયાર.",
      },
      medicalCare: {
        title: "તબીબી સંભાળ",
        desc: "રોજિંદી દવાઓ, ઓન-કોલ ડોક્ટરો, હોસ્પિટલ સાથે જોડાણ.",
      },
      companionship: {
        title: "સંગાથ",
        desc: "સામૂહિક પ્રવૃત્તિઓ, સત્સંગ, તહેવારો અને જન્મદિવસની ઉજવણી.",
      },
      emotionalSupport: {
        title: "ભાવનાત્મક સહારો",
        desc: "કાઉન્સેલિંગ, પરિવાર સાથે વિડિયો કૉલ અને વ્યક્તિગત સંભાળ.",
      },
      ritualsDignity: {
        title: "વિધિ અને ગૌરવ",
        desc: "પુણ્ય તિથિ, અંતિમ સંસ્કાર અને સ્મરણ — આદર સાથે કરવામાં આવે છે.",
      },
    },
    form: {
      eyebrow: "પ્રવેશ માટે અરજી કરો",
      heading: "નિવાસી પ્રવેશ પૂછપરછ",
      description:
        "પ્રવેશ ઇચ્છતા વડીલની સંપૂર્ણ વિગતો શેર કરો. અમારી પ્રવેશ ટીમ 1–2 કાર્યકારી દિવસોમાં સંપર્ક કરશે.",
      select: "પસંદ કરો…",
      submit: "પ્રવેશ પૂછપરછ સબમિટ કરો",
      submitting: "સબમિટ થઈ રહ્યું છે...",
      sections: {
        resident: "નિવાસી વિગતો",
        health: "આરોગ્ય અને ગતિશીલતા",
        admission: "પ્રવેશ વિગતો",
        applicant: "અરજદાર / પરિવાર સંપર્ક",
      },
      labels: {
        residentName: "નિવાસીનું પૂરું નામ *",
        gender: "જાતિ",
        dob: "જન્મ તારીખ",
        bloodGroup: "બ્લડ ગ્રુપ",
        maritalStatus: "વૈવાહિક સ્થિતિ",
        religion: "ધર્મ",
        jainStatus: "જૈન સંપ્રદાય",
        caste: "જ્ઞાતિ / સમુદાય",
        education: "શિક્ષણ",
        occupation: "ભૂતકાળનો વ્યવસાય",
        residentMobile: "નિવાસીનો મોબાઇલ",
        aadhaar: "આધાર નંબર",
        identificationMark: "ઓળખ ચિહ્ન",
        previousAddress: "અગાઉનું સરનામું",
        city: "શહેર",
        state: "રાજ્ય",
        pincode: "પિનકોડ",
        healthConditions: "હાલની આરોગ્ય સમસ્યાઓ",
        currentMedications: "વર્તમાન દવાઓ",
        mobility: "ગતિશીલતા",
        admissionType: "પ્રવેશનો પ્રકાર",
        monthlyMaintenance: "માસિક નિભાવ બજેટ (₹)",
        preferredDate: "પસંદગીની પ્રવેશ તારીખ",
        referredBy: "સંદર્ભ આપનાર",
        reason: "પ્રવેશનું કારણ *",
        applicantName: "અરજદારનું નામ *",
        relation: "નિવાસી સાથેનો સંબંધ",
        mobile: "મોબાઇલ *",
        altMobile: "વૈકલ્પિક મોબાઇલ",
        email: "ઈમેલ",
        applicantAddress: "અરજદારનું સરનામું",
        emergencyName: "કટોકટી સંપર્ક નામ",
        emergencyMobile: "કટોકટી મોબાઇલ",
        emergencyRelation: "કટોકટી સંબંધ",
        notes: "વધારાની નોંધ",
      },
      placeholders: {
        bloodGroup: "દા.ત. B+",
        healthConditions: "ડાયાબિટીસ, બીપી, સાંધાનો દુખાવો, વગેરે.",
        relation: "પુત્ર / પુત્રી / ભત્રીજો…",
      },
      options: {
        gender: {
          male: "પુરુષ",
          female: "સ્ત્રી",
          other: "અન્ય",
        },
        marital: {
          single: "અપરિણીત",
          married: "પરિણીત",
          widowed: "વિધવા/વિધુર",
          divorced: "છૂટાછેડા",
        },
        jain: {
          shwetambar: "શ્વેતાંબર",
          digambar: "દિગંબર",
          sthanakvasi: "સ્થાનકવાસી",
          terapanthi: "તેરાપંથી",
          other: "અન્ય",
        },
        mobility: {
          independent: "સ્વતંત્ર",
          walkingStick: "લાકડી",
          walker: "વૉકર",
          wheelchair: "વ્હીલચેર",
          bedRidden: "પથારીવશ",
        },
        admission: {
          free: "નિ:શુલ્ક",
          paid: "સશુલ્ક",
          subsidised: "સબસિડીયુક્ત",
        },
      },
    },
    toast: {
      error: "સબમિટ કરી શકાયું નહીં.",
      success:
        "પૂછપરછ મળી. અમારી પ્રવેશ ટીમ 1–2 કાર્યકારી દિવસોમાં કૉલ કરશે.",
    },
  },

  healthcare: {
    hero: {
      eyebrow: "ભગવાન મહાવીર હેલ્થકેર પહેલ",
      title: "ભગવાન મહાવીર હેલ્થકેર સેવાઓ",
      subtitle:
        "સર્વાંગી તબીબી સંભાળ, આઈ કેર હોસ્પિટલ, ડેન્ટલ ક્લિનિક અને ગુજરાતનું પ્રથમ વૃદ્ધાશ્રમ પુનર્વસન કેન્દ્ર — વરિષ્ઠ નાગરિકો અને સમુદાયની સમર્પિત સેવા.",
      exploreBtn: "મેડિકલ યુનિટ્સ જુઓ",
      donateBtn: "સહયોગ અને દાન",
    },
    about: {
      eyebrow: "પહેલ વિશે",
      title: "આરોગ્ય સેવાઓ વિશે",
      tagline:
        "વડીલો અને જરૂરિયાતમંદો માટે સમર્પિત તબીબી સારવાર, આધુનિક ક્લિનિક્સ અને કરુણામય સ્વાસ્થ્ય સેવા.",
      body:
        "જીવનધારા વૃદ્ધાશ્રમ ખાતે ભગવાન મહાવીર હેલ્થકેર સર્વિસીસ સર્વાંગી તબીબી સુવિધાઓ પૂરી પાડે છે, જેમાં 24x7 જનરલ ફિઝિશિયન, ભગવાન મહાવીર આઇ કેર હોસ્પિટલ, અદ્યતન ડેન્ટલ ક્લિનિક અને ગુજરાતનું પ્રથમ વૃદ્ધાશ્રમ ફિઝિયોથેરાપી અને રિહેબિલિટેશન સેન્ટર સામેલ છે. તમામ સેવાઓ અમારા વડીલો અને આસપાસના સમુદાયોના સ્વાસ્થ્ય, ગૌરવ અને કલ્યાણ માટે સમર્પિત છે.",
      exploreBtn: "મેડિકલ યુનિટ્સ જુઓ",
      donateBtn: "સહયોગ અને દાન",
    },
    units: {
      eyebrow: "પરિસરમાં મેડિકલ કેન્દ્રો",
      title: "મેડિકલ યુનિટ પસંદ કરો",
      subtitle:
        "સંપૂર્ણ તબીબી સેવાઓ, ડોકટરો, સાધનો અને વિશેષતાઓ જોવા માટે નીચેના કોઈપણ વિભાગ પર ક્લિક કરો.",
      emptyTitle: "કોઈ મેડિકલ યુનિટ નોંધાયેલ નથી",
      emptyDesc: "કૃપા કરીને પછીથી તપાસો અથવા એડમિન પેનલમાં યુનિટ સેટઅપ કરો.",
      clickToView: "વિગતો જોવા માટે ક્લિક કરો",
      defaultBadge: "આરોગ્ય સેવાઓ",
    },
    stats: {
      eyebrow: "❋ સમગ્ર ગુજરાતમાં વિશ્વસનીય આરોગ્ય સેવા પ્રભાવ ❋",
      cataract: "માસિક મોતિયાના ઓપરેશન",
      eyeOpd: "દૈનિક આંખ OPD દર્દીઓ",
      dentalOpd: "માસિક દાંતના OPD દર્દીઓ",
      physioIpd: "દૈનિક ફિઝિયોથેરાપી સત્રો",
      eyeCamps: "નિઃશુલ્ક ગ્રામીણ આંખ તપાસ કેમ્પ",
    },
    contact: {
      inchargeLabel: "મેડિકલ ઇન-ચાર્જ:",
      helplineLabel: "૨૪/૭ કટોકટી હેલ્પલાઇન:",
      defaultIncharge: "સેજલ શાહ (મુખ્ય સંયોજક)",
    },
    sevaYajna: {
      badge: "એક સેવા યજ્ઞ... જે માનવતા જીવંત રાખે છે...",
      centerName: "ભગવાન મહાવીર મેડિકલ સેન્ટર",
      address:
        "જીવનધારા વૃદ્ધાશ્રમ, પદ્માવતી નગર, ઈન્દિરાનગર વિભાગ-2, લાંભા, અમદાવાદ - 382405",
      title: "એક સેવા યજ્ઞ... જે માનવતા જીવંત રાખે છે...",
      p1:
        "આપણે સૌ જાણીએ છીએ કે આજના આ કપરા યુગમાં તબીબી સેવા કેટલી મોંઘી થઈ ગઈ છે. એક સામાન્ય માણસ માટે તો ડોક્ટરની ફી પણ ચૂકવવી મુશ્કેલ છે, તો આર્થિક રીતે પછાત પરિવારનું શું થતું હશે?",
      p2:
        "આ વેદનાને સમજીને અમદાવાદના લાંભા ખાતે વર્ષ 2002 થી જીવનધારા વૃદ્ધાશ્રમ કાર્યરત છે, જ્યાં આજે 298 થી વધુ નિરાધાર વડીલો આશ્રય સ્થાન મેળવી રહ્યા છે.",
      p3:
        "આ વડીલો અને લાંભા આજુબાજુના હજારો જરૂરિયાતમંદ ગ્રામજનોને તબીબી સુવિધા મળી રહે એ હેતુથી સંસ્થા દ્વારા વર્ષ 2011 માં ભગવાન મહાવીર મેડિકલ સેન્ટરની સ્થાપના કરવામાં આવી.",
      servicesHeading:
        "ધીરે ધીરે આ સેવાનો વિસ્તાર વધતો ગયો અને આજે સંસ્થા દ્વારા નીચે મુજબની સેવાઓ પૂરજોશ થી કાર્યરત છે:",
      services: [
        "ભગવાન મહાવીર આઈ કેર હોસ્પિટલ",
        "ભગવાન મહાવીર ડેન્ટલ ક્લિનિક",
        "ભગવાન મહાવીર ફિઝીયોથેરાપી સેન્ટર",
        "પેરાલીસીસ રીહેબીલીટેશન સેન્ટર",
        "24x7 એમ્બ્યુલન્સ સેવા",
      ],
      freeCareNote:
        "જીવનધારા પરિવારના વડીલો માટે આ તમામ સેવાઓ સંપૂર્ણપણે નિ:શુલ્ક છે અને અન્ય જરૂરિયાતમંદ દર્દીઓને ટોકન દરે સેવા આપવામાં આવે છે. હજારો લોકો દર મહિને આ સેવાનો લાભ લે છે.",
      expenseNote:
        "આ સેવા યજ્ઞને ચલાવવા માટે સંસ્થા લાખો રૂપિયાનો ખર્ચ કરે છે. આ પુણ્યના કામમાં આપનો સાથ એ જ સાચી પ્રભુ સેવા છે.",
      joinAppeal:
        "આ સેવા યજ્ઞને ચલાવવા માટે આપ અમારા સહભાગી બની પુણ્ય નું ભાથું ભરો.",
    },
    schemes: {
      eyebrow: "સેવા સહયોગ અને નિભાવ યોજના",
      title: "ભગવાન મહાવીર મેડિકલ સેન્ટર - નિભાવ યોજના",
      subtitle:
        "આ સેવા યજ્ઞને ચલાવવા માટે આપ અમારા સહભાગી બની પુણ્ય નું ભાથું ભરો અને વડીલોની સારવારમાં યોગદાન આપો.",
      pillarTitle: "મુખ્ય આધાર સ્તંભ અને દીર્ઘકાલીન નિભાવ યોજનાઓ",
      regularTitle: "જનરલ અને નિયમિત તબીબી સેવા યોજનાઓ",
      sponsorBtn: "સહયોગ આપો",
      items: {
        mainPillar: "મુખ્ય આધાર સ્તંભ નિભાવ",
        coPillar: "સહ આધાર સ્તંભ નિભાવ",
        lifetimeTithi: "આજીવન તિથિ નિભાવ",
        tenYearTithi: "10 વર્ષ તિથિ નિભાવ",
        generalDaily: "1 દિવસનો જનરલ મેડિકલ નિભાવ (દરેક તબીબી સેવા નો લાભ)",
        monthly: "માસિક નિભાવ",
        oneDay: "1 દિવસનો નિભાવ",
        elderMedicalAid: "વડીલ મેડિકલ સહાય",
        elderDiaper: "વડીલ ડાયપર યોજના",
      },
    },
    appeal: {
      quote:
        "“તમારા એક નાના સહયોગથી કોઈ વૃદ્ધ પિતાને સમયસર દવા મળશે, કોઈ માની આંખોને રોશની મળશે. અચૂક સંપર્ક કરવા નિવેદન...”",
      taxExemptTitle: "80G કરમુક્તિ અને CSR ફંડ",
      taxExemptDesc:
        "આપ દ્વારા આપવામાં આવેલ દાન આવકવેરા કાયદાની કલમ 80G હેઠળ 100% કરમુક્ત છે. CSR ફંડ સ્વીકાર્ય છે.",
      helplineTitle: "સંપર્ક નંબર:",
      motto: "“જન સેવા એ જ પ્રભુ સેવા” - આવો, આ સેવા યજ્ઞમાં જોડાઈએ.",
    },
  },

  elderCare: {
    hero: {
      eyebrow: "વડીલ સંભાળ",
      title: "આજીવન સંભાળ, ગૌરવ સાથે",
      subtitle:
        "આશ્રય, ભોજન, દવા, સંગાથ અને વિધિઓ — પરિવારની હૂંફ સાથે પૂરા પાડવામાં આવે છે, ક્યારેય દયા તરીકે નહીં.",
    },
    impact: {
      residentsCared: "સંભાળ પામેલા નિવાસીઓ",
      lifetimeCare: "આજીવન સંભાળના",
      lastRites: "ગૌરવપૂર્ણ અંતિમવિધિ",
      donorFunded: "દાતા દ્વારા ભંડોળ",
    },
    overview: {
      eyebrow: "કાર્યક્રમ ઝાંખી",
      heading: "ઓરડા અને ભોજનથી આગળ વધતી સંભાળ",
      description:
        "દરેક નિવાસીને એક સમાન સ્તરની સંભાળ મળે છે — ભલે તેઓ સાધન સાથે આવ્યા હોય કે કંઈ પણ વગર.",
    },
    services: {
      shelter: {
        title: "આજીવન આશ્રય",
        body: "સ્વચ્છ, સુરક્ષિત ઓરડો અને પરિવારના ભોજનમાં સ્થાન — જ્યાં સુધી અમારા વડીલોને જરૂર હોય ત્યાં સુધી, વિના મૂલ્યે.",
      },
      bhojan: {
        title: "દૈનિક ભોજન સેવા",
        body: "દરરોજ ત્રણ પૌષ્ટિક, તાજાં રાંધેલા જૈન-શૈલીના ભોજન, આહારની જરૂરિયાતને ધ્યાનમાં રાખીને આયોજિત.",
      },
      care: {
        title: "ચોવીસ કલાક સંભાળ",
        body: "પ્રશિક્ષિત સંભાળકર્તાઓ, રોજિંદા ડોક્ટર રાઉન્ડ અને સહાયની જરૂર હોય તેવા નિવાસીઓ માટે 24×7  ડોક્ટર, તબીબી સારવાર, નર્સિંગ તથા એમ્બ્યુલન્સ.",
      },
      dignity: {
        title: "ગૌરવ અને વિધિઓ",
        body: "જન્મદિવસ, તહેવારો અને અંતિમ સંસ્કાર પરિવાર જેવી જ સંભાળ સાથે ઉજવાય છે.",
      },
      physio: {
        title: "ગુજરાતમાં પ્રથમ - પક્ષઘાત પુનર્વસન સેન્ટર",
        body: "ગુજરાતનું પ્રથમ વૃદ્ધાશ્રમ પક્ષઘાત (પેરાલિસિસ) પુનર્વસન અને ફિઝિયોથેરાપી સેન્ટર — વડીલોના પુનર્વસન અને ચળવળ માટે.",
      },
    },
    facilities: {
      imgAlt: "સાથે ભોજનનો આનંદ માણતા નિવાસીઓ",
      eyebrow: "સુવિધાઓ અને સેવાઓ",
      heading: "અમારા વડીલોને કેન્દ્રમાં રાખીને બનેલું ઘર",
      description:
        "ગતિશીલતા, સલામતી અને સમુદાયને ધ્યાનમાં રાખીને રચાયેલું — જ્યાં દરેક ખૂણામાં પ્રેમ અને હૂંફ છે.",
      items: {
        capacity: "A, B અને C બ્લોકમાં 360+ નિવાસીઓની ક્ષમતા",
        clinic: "રોજિંદા નર્સિંગ રાઉન્ડ સાથેનું પોતાનું ક્લિનિક",
        physio: "ફિઝિયોથેરાપી અને યોગ ખંડ",
        library: "પુસ્તકાલય, પ્રાર્થના ખંડ અને સત્સંગ સ્થળ",
        access: "સર્વત્ર વ્હીલચેર-અનુકૂળ પ્રવેશ",
        garden: "બગીચો, ચાલવાના માર્ગ અને બહારની બેઠક",
        entertainment: "મનોરંજન હોલ, મૂવી હોલ : પુસ્તકાલય, પ્રાર્થના ખંડ અને સત્સંગ સ્થળ",
      },
    },
    stories: {
      eyebrow: "પ્રભાવ ગાથાઓ",
      heading: "અમારા પરિવારનો પડઘો",
      items: {
        kantilal: {
          name: "કાંતિલાલ ભાઈ",
          years: "અમારી સાથે 12 વર્ષ",
          quote: "હું એકલો આવ્યો હતો. હવે મારે પરિવાર છે — 119 ભાઈઓ અને બહેનો.",
        },
        saroj: {
          name: "સરોજ બેન",
          years: "અમારી સાથે 5 વર્ષ",
          quote:
            "અહીં આવ્યા પછી દરેક જન્મદિવસે કેક હોય છે. હું ભૂલી ગઈ હતી કે એ કેવું લાગે છે.",
        },
        hasmukh: {
          name: "હસમુખ ભાઈ",
          years: "અમારી સાથે 9 વર્ષ",
          quote:
            "જ્યારે હું બીમાર પડ્યો, ત્યારે ડોક્ટર મધ્યરાત્રિએ આવ્યા. બીજે ક્યાં આવું બને?",
        },
      },
    },
    gallery: {
      eyebrow: "ફોટો ગેલેરી",
      heading: "અમારા ઘરની પ્રેમ ભરી ક્ષણો",
      viewFull: "સંપૂર્ણ ગેલેરી જુઓ",
      items: {
        care: "કરુણામય સંભાળ",
        meals: "સહિયારું ભોજન",
        health: "રોજિંદી આરોગ્ય તપાસ",
      },
    },
    cta: {
      tagline: "અમારે માવતર જોઈએ છે.",
      heading: "એક વડીલની સંભાળ પ્રાયોજિત કરો",
      description:
        "તમારો સહકાર જીવનધારા વૃદ્ધાશ્રમના વડીલો માટે આશ્રય, ભોજન અને દવાનું ભંડોળ પૂરું પાડે છે.",
      support: "વડીલ સંભાળને સહકાર આપો",
      visit: "ઘરની મુલાકાત લો",
    },
  },
};

export default care;
